import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const LetSheet = ({ open, onClose, onLet, onDispute }) => (
  <AnimatePresence>
    {open && (
      <div className="fixed inset-0 z-[170] flex items-end justify-center">
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="absolute inset-0 bg-slate-950/70 backdrop-blur-sm" onClick={onClose} />
        <motion.div
          initial={{ y: '100%' }} animate={{ y: 0 }} exit={{ y: '100%' }}
          transition={{ type: 'spring', damping: 28, stiffness: 320 }}
          className="relative z-10 w-full max-w-lg bg-[#0d1a2e] border-t border-white/10 rounded-t-3xl px-4 pt-4"
          style={{ paddingBottom: 'max(1.5rem, env(safe-area-inset-bottom))' }}
        >
          <div className="w-10 h-1 rounded-full bg-white/20 mx-auto mb-5" />
          <h3 className="text-base font-black text-white mb-1.5">發球違例 / 爭議處理</h3>
          <p className="text-xs text-white/40 font-bold mb-5">選擇處理方式，不影響比分記錄</p>

          <div className="space-y-3">
            {/* Let */}
            <button onClick={onLet}
              className="w-full flex items-start gap-4 p-4 rounded-2xl border text-left transition-all active:scale-[0.98] hover:bg-white/[0.06]"
              style={{ backgroundColor: 'rgba(251,191,36,0.08)', borderColor: 'rgba(251,191,36,0.3)' }}>
              <div className="text-3xl shrink-0">🔄</div>
              <div>
                <p className="font-black text-amber-300 text-sm mb-1">Let（重打）</p>
                <p className="text-xs text-white/50 font-bold leading-relaxed">
                  不改分，記錄重打事件。發球員和站位維持不變，重新發球。
                </p>
              </div>
            </button>

            {/* Dispute */}
            <button onClick={onDispute}
              className="w-full flex items-start gap-4 p-4 rounded-2xl border text-left transition-all active:scale-[0.98] hover:bg-white/[0.06]"
              style={{ backgroundColor: 'rgba(168,85,247,0.08)', borderColor: 'rgba(168,85,247,0.3)' }}>
              <div className="text-3xl shrink-0">⚖️</div>
              <div>
                <p className="font-black text-purple-300 text-sm mb-1">裁判改判</p>
                <p className="text-xs text-white/50 font-bold leading-relaxed">
                  撤銷上一分，返回上一球狀態，可重新指定發球員 / 站位後繼續。
                </p>
              </div>
            </button>

            <button onClick={onClose}
              className="w-full py-3 rounded-2xl bg-white/5 border border-white/10 text-white/40 font-black text-sm hover:bg-white/10 transition-all">
              取消
            </button>
          </div>
        </motion.div>
      </div>
    )}
  </AnimatePresence>
);

export default LetSheet;